<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="DED"><span class="ePub-I">This one is for Peter S. Beagle.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?348ed01a